<script>
import aliases from '../../../../../theme/uiIconAliases.json';

export default {
  props: {
    icon: { type: String, required: true },
    // Retain the public component contract for older consumers.
    icons: { type: Object, default: () => ({}) }, // eslint-disable-line vue/no-unused-properties
    size: { type: [String, Number], default: '20' },
    type: { type: String, default: 'outline' }, // eslint-disable-line vue/no-unused-properties
    viewBox: { type: String, default: '0 0 24 24' }, // eslint-disable-line vue/no-unused-properties
    iconLib: { type: String, default: 'fluent' }, // eslint-disable-line vue/no-unused-properties
  },
  computed: {
    iconClass() {
      return aliases.legacy[this.icon]
        ? `i-legacy-${this.icon}`
        : 'i-hugeicons-help-circle';
    },
    dimensions() {
      const size = /^\d+(\.\d+)?$/.test(String(this.size))
        ? `${this.size}px`
        : this.size;
      return { width: size, height: size };
    },
  },
};
</script>

<template>
  <span
    :class="iconClass"
    :style="dimensions"
    class="inline-block shrink-0 align-middle"
    aria-hidden="true"
  />
</template>
